// src/config/config.js

export const usdJGKDecimalConversionRate = 0.001;
export const usdJGKConversionRate = 1000; // 1 USD === 1000 JGK
export const sendReferralEmailJGKRate = 20; // 20 JGK for sending referral email
export const jgkTransactionFee = 0.03; // 3% transaction fee
